import { css } from "@emotion/react";

export const relativeFieldWrapperCss = css`
  position: relative;
`;

export const fieldMessageWrapperCss = css`
  position: absolute;
  z-index: 99999;
  top: 100%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  padding: 4px;
  font-size: 13px;
  border-radius: 4px;
`;
